import { seoResolver } from "../../modules/app-route";
import { AppRoutes } from "../../modules/app-route/models/app-route.model";

export const WETTER_ROUTES: AppRoutes = [
    {
        path: "",
        loadComponent: () => import('./components/wetter-carousel/wetter-carousel.component').then(mod => mod.WetterCarouselComponent),
        outlet: "carousel"
    },
    {
        path: "",
        loadComponent: () => import('./components/wetter-home/wetter-home.component').then(mod => mod.WetterHomeComponent),
        title: 'Wind und Wetter am Steinhuder Meer',
        data: {
            meta: {
                description: 'Wetterbericht für das Steinhuder Meer, Wettervorhersage für das Steinhuder Meer, 10 Tage Wetter, stündliche Wettervorhersage, Ostenmeer'
            }
        },
        resolve: { seo: seoResolver },
    },
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full'
    }
];